  (function () {

    function calcDisplayCount(cart) {
      if (!cart || !Array.isArray(cart.items)) return 0;

      let count = 0;
      for (const item of cart.items) {
        const props = item.properties || {};
        const isKgDropdown = props._kg_dropdown != null && String(props._kg_dropdown).length > 0;

        if (isKgDropdown) {
          count += 1;
        } else {
          const q = Number(item.quantity || 0);
          count += Number.isFinite(q) ? q : 0;
        }
      }
      return count;
    }

    async function updateCartBubbleLineCount() {
      try {
        const response = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await response.json();

        // ★行数ではなく、表示用カウントにする
        const displayCount = calcDisplayCount(cart);

        const bubbles = document.querySelectorAll('#cart-icon-bubble [data-cart-bubble="true"]');
        bubbles.forEach(bubble => {
          const target = bubble.querySelector('[aria-hidden="true"]') || bubble;

          target.textContent = displayCount;

          bubble.style.display = displayCount > 0 ? '' : 'none';
          bubble.style.visibility = 'visible';
        });

      } catch (error) {
        console.warn('[cart bubble] update failed:', error);
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      updateCartBubbleLineCount();
    });

    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);

      try {
        const url = typeof args[0] === 'string'
          ? args[0]
          : (args[0] && args[0].url) || '';

        if (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update')
        ) {
          setTimeout(updateCartBubbleLineCount, 50);
          setTimeout(updateCartBubbleLineCount, 300);
          setTimeout(updateCartBubbleLineCount, 800);
        }
      } catch (e) {}

      return response;
    };

  })();
